import { Link } from "react-router-dom";
import { ArrowLeft, Gamepad2, ShieldCheck, Users } from "lucide-react";
import { Logo } from "@/components/layout/Logo";
import { ThemeToggle } from "@/components/layout/ThemeToggle";

const POINTS = [
  { icon: Gamepad2, t: "Drive SPIKE™ Prime robots with an Xbox® controller" },
  { icon: ShieldCheck, t: "Robot setups saved safely to your account" },
  { icon: Users, t: "Free for every student and teacher" },
];

export const AuthLayout = ({ children, testId }) => (
  <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]" data-testid={testId}>
    <aside className="relative hidden overflow-hidden bg-primary p-12 text-primary-foreground lg:flex lg:flex-col lg:justify-between">
      <div className="absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-accent/90 dark:bg-white/10" />
      <div className="relative [&_a]:text-primary-foreground"><Logo /></div>
      <div className="relative">
        <h2 className="text-4xl font-extrabold leading-tight tracking-tight">Build it. Set it up.<br />Drive it.</h2>
        <ul className="mt-8 space-y-4">
          {POINTS.map(({ icon: Icon, t }) => (
            <li key={t} className="flex items-center gap-3 text-base"><span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/15"><Icon className="h-4 w-4" /></span>{t}</li>
          ))}
        </ul>
      </div>
      <p className="relative text-xs opacity-75">LEGO® and SPIKE™ are trademarks of the LEGO Group, which does not sponsor this site. Xbox® is a registered trademark of Microsoft Corporation.</p>
    </aside>
    <main className="flex flex-col">
      <div className="flex items-center justify-between p-4 sm:p-6">
        <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground" data-testid="auth-back-link">
          <ArrowLeft className="h-4 w-4" />Home
        </Link>
        <ThemeToggle />
      </div>
      <div className="flex flex-1 items-center justify-center px-4 pb-12">{children}</div>
    </main>
  </div>
);
